import { useJdmForgotPasswordMutation } from '../../apis/jdmPasswordApi';

const useForgotPassword = () => {
    const [forgotPassword, { isLoading, isSuccess, isError, reset }] = useJdmForgotPasswordMutation();

    return {
        forgotPassword: (username: string) => forgotPassword(username),
        isLoading,
        hasCompleted: isSuccess || isError, // For security reasons we do not show errors for non-existent usernames.
        reset,
    };
};

export default useForgotPassword;
